import React from "react";
import { motion } from "framer-motion";

const Reveal = ({ children, delay = 0, y = 36, style, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.18 }}
    transition={{ duration: 0.7, ease: [0.22, 0.72, 0.18, 1], delay }}
    style={{ width: "100%", ...style }}
    {...rest}
  >
    {children}
  </motion.div>
);

export default Reveal;
